import { render, staticRenderFns } from "./JobCompleted.vue?vue&type=template&id=baf1cd7e"
import script from "./JobCompleted.vue?vue&type=script&lang=js"
export * from "./JobCompleted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports